document.addEventListener('DOMContentLoaded', () => {

  let currentDropdown = null;

  // Function to set tabindex values for a specific column
  function setColumnTabIndexes(columnNumber) {
    const tabindexBase = columnNumber * 100;
    const column = document.querySelector(`.comparison-table__column[data-column="${columnNumber}"]`);
    
    if (!column) return;
    
    const isMobile = window.innerWidth <= 1000;
    
    // Set tabindex for all feature-value elements in order
    const featureRows = column.querySelectorAll('.feature-row');
    featureRows.forEach((row, index) => {
      const featureValue = row.querySelector('.feature-value');
      const featureMobileInfo = row.querySelector('.feature-mobile-info');
      
      if (featureValue) {
        if (isMobile && featureMobileInfo) {
          // On mobile, set tabindex on mobile-info and remove from feature-value
          featureMobileInfo.removeAttribute('hidden');
          featureMobileInfo.setAttribute('tabindex', tabindexBase + index + 1);
          featureValue.removeAttribute('tabindex');
        } else {
          // On desktop, set tabindex on feature-value and hide mobile-info
          if (featureMobileInfo) {
            featureMobileInfo.setAttribute('hidden', '');
            featureMobileInfo.removeAttribute('tabindex');
          }
          featureValue.setAttribute('tabindex', tabindexBase + index + 1);
        }
      }
    });
    
    // Set tabindex for other interactive elements
    const viewProductLink = column.querySelector('.feature-row__view .view-product');
    if (viewProductLink) {
      viewProductLink.setAttribute('tabindex', tabindexBase + 20);
    }
    
    const addToCartButton = column.querySelector('.feature-row__add button');
    if (addToCartButton) {
      addToCartButton.setAttribute('tabindex', tabindexBase + 21);
    }
    
    // Set tabindex for variant swatches if they exist
    const variantSwatches = column.querySelectorAll('.feature-row__variant-swatches input[type="radio"]');
    variantSwatches.forEach((swatch, index) => {
      swatch.setAttribute('tabindex', tabindexBase + 11 + index);
    });
    
    // Set tabindex for the header elements
    const headerColumn = document.querySelector(`.comparison-table__product-info[data-column="${columnNumber}"]`);
    if (headerColumn) {
      const headerLink = headerColumn.querySelector('.image-wrapper a');
      if (headerLink) {
        headerLink.setAttribute('tabindex', tabindexBase);
      }
      
      const dropdownTrigger = headerColumn.querySelector('.select__trigger button');
      if (dropdownTrigger) {
        dropdownTrigger.setAttribute('tabindex', tabindexBase + 1);
      }
    }
  }

  function closeDropdown(moveFocusToNext = false) {
    if (currentDropdown) {
      const selectUl = currentDropdown.querySelector('.select ul');
      currentDropdown.querySelector('.select').classList.remove('open');
      selectUl.setAttribute('aria-expanded', 'false');
      selectUl.setAttribute('aria-pressed', 'false');
      
      // Remove the keyboard navigation event listener when closing dropdown
      document.removeEventListener('keydown', currentDropdown.handleKeyboardNavigation);
      
      // Find the associated trigger button
      const dropdownId = currentDropdown.id;
      const triggerNumber = dropdownId.replace('productHandlesDropdown', '');
      const triggerId = `dropdownTrigger${triggerNumber}`;
      const triggerButton = document.getElementById(triggerId);
      
      // If moveFocusToNext is true, find the next tabbable element in the sequence
      if (moveFocusToNext && triggerButton) {
        const columnNumber = triggerNumber;
        
        // Find the corresponding content column
        const contentColumn = document.querySelector(`.comparison-table__column[data-column="${columnNumber}"]`);
        if (contentColumn) {
          const isMobile = window.innerWidth <= 1000;
          
          if (isMobile) {
            // On mobile, focus the first feature-mobile-info element
            const firstFeatureMobileInfo = contentColumn.querySelector('.feature-mobile-info[tabindex]');
            if (firstFeatureMobileInfo) {
              firstFeatureMobileInfo.focus();
            } else {
              // Fallback to the trigger button if we can't find a feature-mobile-info
              triggerButton.focus();
            }
          } else {
            // On desktop, focus the first feature-value element
            const firstFeatureValue = contentColumn.querySelector('.feature-value[tabindex]');
            if (firstFeatureValue) {
              firstFeatureValue.focus();
            } else {
              // Fallback to the trigger button if we can't find a feature-value
              triggerButton.focus();
            }
          }
        } else {
          // Fallback to the trigger button if we can't find the content column
          triggerButton.focus();
        }
      } else if (triggerButton) {
        // Default behavior: return focus to the trigger button
        triggerButton.focus();
      }
      
      currentDropdown = null; // Reset current open dropdown
    }
  }

  function handleDropdownChange(dropdownId, targetDivId, targetHeaderId, dropdownTriggerId) {
    const dropdown = document.getElementById(dropdownId);
    const targetHeader = document.getElementById(targetHeaderId);
    // Array of all possible dropdown IDs
    const dropdowns = ['productHandlesDropdown1', 'productHandlesDropdown2', 'productHandlesDropdown3'];
  
    // Determine other dropdowns by filtering out the current one
    const otherDropdownIds = dropdowns.filter(id => id !== dropdownId && document.getElementById(id));
  
    // Function to check if dropdown is open
    function isOpen() {
      return dropdown.querySelector('.select').classList.contains('open');
    }
  
    // Function to open the dropdown
    function openDropdown() {
      closeDropdown(); 
      const selectUl = dropdown.querySelector('.select ul');
      const headerTitleWidth = targetHeader.querySelector('#headerTitle').getBoundingClientRect().width;
      var dropdownWidth = headerTitleWidth + 39;
  
      selectUl.style.width = `${dropdownWidth}px`;
      dropdown.querySelector('.select').classList.toggle('open');
      selectUl.setAttribute('aria-expanded', 'true');
      selectUl.setAttribute('aria-pressed', 'true');
      currentDropdown = dropdown; // This line is crucial
      
      // Store the handleKeyboardNavigation function on the dropdown element
      dropdown.handleKeyboardNavigation = handleKeyboardNavigation;
      
      // Add keyboard event listener for arrow navigation when dropdown is open
      document.addEventListener('keydown', handleKeyboardNavigation);
      
      // Find the currently selected option and focus it
      const selectedOption = dropdown.querySelector('.custom-option.selected');
      
      if (selectedOption) {
        // Clear any previous active states
        dropdown.querySelectorAll('.custom-option').forEach(opt => {
          opt.classList.remove('is-active');
          opt.setAttribute('aria-selected', 'false');
        });
        
        selectedOption.classList.add('is-active');
        selectedOption.setAttribute('aria-selected', 'true');
        selectedOption.focus();
      }
    }
    
    // Function to handle keyboard navigation within the dropdown
    function handleKeyboardNavigation(e) {
      // Only process arrow keys if dropdown is open
      if (!isOpen()) return;
      
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); // Prevent page scrolling
        
        // Get all available options (not disabled)
        const options = Array.from(dropdown.querySelectorAll('.custom-option:not(.disabled-default)'));
        if (!options.length) return;
        
        // Find currently focused/active option
        const currentActive = dropdown.querySelector('.custom-option.is-active');
        let currentIndex = options.indexOf(currentActive);
        
        // If no option is active, start from the selected one
        if (currentIndex === -1) {
          const selectedOption = dropdown.querySelector('.custom-option.selected');
          currentIndex = selectedOption ? options.indexOf(selectedOption) : 0;
        }
        
        let nextIndex;
        if (e.key === 'ArrowDown') {
          // Move to next option or loop to first
          nextIndex = currentIndex >= options.length - 1 ? 0 : currentIndex + 1;
        } else {
          // Move to previous option or loop to last
          nextIndex = currentIndex <= 0 ? options.length - 1 : currentIndex - 1;
        }
        
        // Remove active class from all options
        dropdown.querySelectorAll('.custom-option').forEach(opt => {
          opt.classList.remove('is-active');
          opt.setAttribute('aria-selected', 'false');
        });
        
        // Add active class to the new option
        options[nextIndex].classList.add('is-active');
        options[nextIndex].setAttribute('aria-selected', 'true');
        options[nextIndex].focus();
      } else if (e.key === 'Enter' && isOpen()) {
        // Select the currently active option on Enter
        const activeOption = dropdown.querySelector('.custom-option.is-active');
        if (activeOption && !activeOption.classList.contains('disabled-default')) {
          activeOption.click();
        }
      } else if (e.key === 'Escape') {
        // Close dropdown on Escape key
        closeDropdown();
      }
    }
  
    // Open or close the dropdown
    if (isOpen()) {
      closeDropdown();
      return;
    } else {
      openDropdown();
    }
  
    // Loop through options to handle selection
    for (const option of dropdown.querySelectorAll(".custom-option")) {
      option.addEventListener('click', function() {
        if (!this.classList.contains('selected') && !this.classList.contains('disabled-default')) {
          const previouslySelectedValue = dropdown.querySelector('.custom-option.selected')?.getAttribute('value');
          dropdown.querySelectorAll('.custom-option').forEach(opt => {
            opt.setAttribute('aria-selected', 'false');
            opt.classList.remove('is-active');
          });
          this.setAttribute('aria-selected', 'true');
          this.classList.add('is-active');
          this.parentNode.querySelector('.custom-option.selected')?.classList.remove('selected');
          this.classList.add('selected');
          const selectedHandle = this.getAttribute('value');
  
          // Gather currently selected options across all dropdowns
          const currentlySelectedOptions = dropdowns.map(dropdownId => {
            const dropdownElement = document.getElementById(dropdownId);
            return dropdownElement ? dropdownElement.querySelector('.custom-option.selected')?.getAttribute('value') : null;
          }).filter(value => value !== null && value !== selectedHandle);
  
          // Enable previously selected option if it's not selected in another dropdown
          if (previouslySelectedValue && !currentlySelectedOptions.includes(previouslySelectedValue)) {
            dropdowns.forEach(dropdownId => {
              const optionToEnable = document.querySelector(`#${dropdownId} .custom-option[value="${previouslySelectedValue}"]`);
              if (optionToEnable) {
                optionToEnable.classList.remove('disabled-default');
              }
            });
          }
  
          // Disable the newly selected option in other dropdowns
          otherDropdownIds.forEach(otherDropdownId => {
            const optionToDisable = document.querySelector(`#${otherDropdownId} .custom-option[value="${selectedHandle}"]`);
            if (optionToDisable) {
              optionToDisable.classList.add('disabled-default');
            }
          });
  
          // Fetch new product markup based on the selected option
          fetch(`/products/${selectedHandle}?section_id=sr-api-compare-col`)
            .then(response => {
              if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.text();
            })
            .then(productMarkup => {
              // Update the UI with the fetched product markup
              document.getElementById(targetDivId).innerHTML = productMarkup;
              let tempDiv = document.createElement('div');
              tempDiv.innerHTML = productMarkup;
  
              // Update various parts of the UI with the new content
              let headerComponents = ['#headerImage', '#headerPricing', '#headerTitle', '#mobileCustomBadge', '#desktopCustomBadge'];
              headerComponents.forEach(component => {
                let markup = tempDiv.querySelector(component).innerHTML;
                document.querySelector(`#${targetHeaderId} ${component}`).innerHTML = markup;
              });
              
              // Re-apply tabindex values to the updated column
              const columnNumber = dropdownId.replace('productHandlesDropdown', '');
              
              // Update tabindex values for this column before setting focus
              setColumnTabIndexes(columnNumber);

              
              // Close the dropdown and move focus to the next tabbable element
              closeDropdown(true);
            })
            .catch(error => {
              console.error('Error fetching product markup:', error);
            });
        } else {
          // Close the dropdown even if the option is already selected
          closeDropdown();
        }
      });
  
      // Allow selection with the Enter key
      option.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          this.click();
          // The click handler will take care of closing the dropdown
        }
      });
    }
  }

  // Listeners for the dropdowns
  for (let i = 1; i <= 3; i++) {
    let dropdownTrigger = document.getElementById(`dropdownTrigger${i}`);

    dropdownTrigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation(); // Prevent the event from bubbling up
      handleDropdownChange(`productHandlesDropdown${i}`, `product-slot-${i}`, `headingContainerSlot${i}`, `dropdownTrigger${i}`);
    });

    // Add listener for the h2 element and the span element preceding the button
    let spanElement = dropdownTrigger.parentElement.previousElementSibling;
    let h2Element = spanElement ? spanElement.previousElementSibling : null;

    if (h2Element && h2Element.tagName === 'H2') {
      h2Element.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation(); // Prevent the event from bubbling up
        handleDropdownChange(`productHandlesDropdown${i}`, `product-slot-${i}`, `headingContainerSlot${i}`, `dropdownTrigger${i}`);
      });
    }

    if (spanElement && spanElement.tagName === 'SPAN') {
      spanElement.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation(); // Prevent the event from bubbling up
        handleDropdownChange(`productHandlesDropdown${i}`, `product-slot-${i}`, `headingContainerSlot${i}`, `dropdownTrigger${i}`);
      });
    }
  }

  // Function to handle tooltip trigger
  document.querySelectorAll('button#tooltipTrigger').forEach(function(tooltipTrigger) {
    tooltipTrigger.addEventListener('click', function(event) {
      event.stopPropagation();
      const tooltipContent = this.nextElementSibling;
      tooltipContent.classList.toggle('active');
    });
  });

  // Clicking on anything other than the tooltipTrigger or the actual tooltipContent should remove the active class
  document.addEventListener('click', function(event) {
    document.querySelectorAll('.tooltip-content.active').forEach(function(tooltipContent) {
      tooltipContent.classList.remove('active');
    });

    if (!currentDropdown) return;
    if (!currentDropdown.contains(event.target)) {
      closeDropdown();
    }
  });

  // Pressing escape should remove the active class
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('.tooltip-content.active').forEach(function(tooltipContent) {
        tooltipContent.classList.remove('active');
      });
      if (currentDropdown) {
        closeDropdown();
      }
    }
  });

  
// Attach the listeners to the comparison table columns as these persist in the DOM when the SR API updates the individual components of the column. 
const comparisonTableColumns = document.querySelectorAll('.comparison-table__column');

// Attach and delegagte the event listeners to each column
comparisonTableColumns.forEach(column => {
  column.addEventListener('click', function(event) {
    if (event.target.matches('.feature-row__variant-swatches input[type="radio"]')) {
      const radio = event.target;

      // Update the nearest span.variant-value text with the value of the clicked radio input
      const variantValueSpan = radio.closest('.feature-row__variant-swatches').querySelector('.variant-value');
      if (variantValueSpan) {
        variantValueSpan.textContent = radio.value;
      }

      // Find the form with the matching ID from the radio input's form attribute
      const formId = radio.getAttribute('form');
      const form = document.getElementById(formId);
      if (form) {
        // Find the input with name="id" within the form and replace its value with the data-variant-id of the clicked radio input
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) {
          idInput.value = radio.getAttribute('data-variant-id');
        }
      }
    }
  });
});

  // Function to update all columns' tabindex values 
  function updateAllColumnsTabindex() {
    for (let i = 1; i <= 3; i++) {
      setColumnTabIndexes(i);
    }
  }

  // Initialize tabindex values for all columns on page load
  function initializeTabIndexes() {
    updateAllColumnsTabindex();
  }

  // Resize event listener to update tabindex values when screen size changes
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      updateAllColumnsTabindex();
      if (currentDropdown) {
        closeDropdown();
      }
    }, 250);
  });

  initializeTabIndexes();
});
